const calcularViabilidadRuta = (
	fechaObjetivo
) => {

	const hoy =
		new Date();

	const fecha =
		new Date(
			fechaObjetivo
		);

	const diasRestantes =
		Math.max(
			0,
			Math.ceil(
				(
					fecha - hoy
				)
				/
				(
					1000 *
					60 *
					60 *
					24
				)
			)
		);

	let estadoViabilidad =
		"verde";

	if (
		diasRestantes <= 120
	) {

		estadoViabilidad =
			"amarillo";
	}

	if (
		diasRestantes <= 29
	) {

		estadoViabilidad =
			"rojo";
	}

	if (
		diasRestantes <= 6
	) {

		estadoViabilidad =
			"critico";
	}

	return {

		diasRestantes,

		estadoViabilidad
	};
};

export default
	calcularViabilidadRuta;